import { useClassroomQuery } from '@innovamat/glow-api-client';

type Props = {
  classroomId?: string;
};

function useClassroom({ classroomId }: Props) {
  const { data, isLoading, isError } = useClassroomQuery(
    {
      id: classroomId || '',
    },
    {
      enabled: !!classroomId,
    }
  );

  return { classroom: data?.classroom, isLoading, isError };
}

export { useClassroom };
